<template>
  <div class="p-m-3 sp-page">
    <MockBanner />
    <div v-if="!site"><h3>Site not found</h3></div>
    <div v-else>
      <div class="sp-row">
        <div>
          <span class="sp-muted">Site</span>
          <h2 style="margin: 0;">{{ site.name }}</h2>
          <div class="sp-muted">{{ [site.address1, site.address2, site.town, site.county, site.postCode].filter(Boolean).join(', ') }}</div>
        </div>
        <span class="sp-spacer"></span>
        <Button label="Edit site" icon="pi pi-pencil" class="p-button-outlined" disabled />
        <Button label="New project on this site" icon="pi pi-plus" class="p-button-success" @click="formVisible = true" />
      </div>

      <div class="sp-row p-mt-3">
        <div class="sp-kpi"><div class="label">Projects</div><div class="value">{{ projectRows.length }}</div></div>
        <div class="sp-kpi"><div class="label">Enquiries</div><div class="value">{{ enquiryRows.length }}</div></div>
        <div class="sp-kpi"><div class="label">Customers quoting</div><div class="value">{{ customerCount }}</div></div>
        <div class="sp-kpi">
          <div class="label">Project-basis value (live)</div><div class="value">{{ money(totalCounted) }}</div>
          <div class="hint">Live quotes added up: {{ money(totalLiveSum) }}</div>
        </div>
      </div>

      <div class="p-card p-p-3 p-mt-3">
        <h4 style="margin-top: 0;">Projects on this site</h4>
        <table class="sp-table">
          <thead>
            <tr><th>Project</th><th>Status</th><th>Product types</th><th>Enquiries</th><th>Customers</th><th class="sp-money">Project-basis £</th><th class="sp-money">Live quotes added up £</th><th>Created</th></tr>
          </thead>
          <tbody>
            <tr v-for="p in projectRows" :key="p.id">
              <td><span class="sp-link" @click="$router.push('/sitesProjects/projects/' + p.id)">{{ p.name }}</span></td>
              <td><span :class="'sp-chip ' + p.status">{{ p.status }}</span></td>
              <td>{{ p.totals.productTypes.join(', ') || '—' }}</td>
              <td>{{ p.totals.nEnquiries }}</td>
              <td>{{ p.totals.nCustomers }}</td>
              <td class="sp-money">{{ money(p.totals.counted) }}</td>
              <td class="sp-money sp-muted">{{ money(p.totals.liveSum) }}</td>
              <td>{{ p.created }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="p-card p-p-3 p-mt-3">
        <h4 style="margin-top: 0;">Everyone quoting on this site</h4>
        <p class="sp-sub">So a rep working one building can see who else is on the scheme.</p>
        <table class="sp-table">
          <thead><tr><th>Customer</th><th>Role</th><th>Projects</th><th>Enquiries</th><th>Branches</th><th>Latest</th></tr></thead>
          <tbody>
            <tr v-for="c in customerRows" :key="c.customer">
              <td>{{ c.customer }}</td>
              <td><span v-if="c.role" class="sp-chip role">{{ c.role }}</span></td>
              <td>{{ c.projects }}</td>
              <td>{{ c.n }}</td>
              <td>{{ c.branches }}</td>
              <td>{{ c.latest }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <ProjectForm v-if="formVisible" :visible="formVisible" :presetSiteId="site && site.id" @close="formVisible = false" @picked="onPicked" />
  </div>
</template>

<script>
import MockBanner from './MockBanner.vue'
import ProjectForm from './ProjectForm.vue'
import { siteById, projectsOfSite, projectTotals, projectStatus, enquiriesOfProject, projectById, money } from './mockData'

export default {
  name: 'SpSiteDetail',
  components: { MockBanner, ProjectForm },
  data() { return { formVisible: false, version: 0 } },
  computed: {
    site() { return siteById(+this.$route.params.id) },
    projectRows() {
      this.version
      if (!this.site) return []
      return projectsOfSite(this.site.id).map(p => ({ ...p, status: projectStatus(p.id), totals: projectTotals(p.id) }))
    },
    enquiryRows() { return this.projectRows.flatMap(p => enquiriesOfProject(p.id)) },
    customerCount() { return new Set(this.enquiryRows.map(e => e.customer)).size },
    totalCounted() { return this.projectRows.reduce((a, p) => a + p.totals.counted, 0) },
    totalLiveSum() { return this.projectRows.reduce((a, p) => a + p.totals.liveSum, 0) },
    customerRows() {
      const by = {}
      this.enquiryRows.forEach(e => {
        const c = by[e.customer] || (by[e.customer] = { customer: e.customer, role: e.role, projects: new Set(), branches: new Set(), n: 0, latest: e.created })
        c.projects.add(projectById(e.projectId).name)
        c.branches.add(e.branch)
        c.n++
        c.latest = e.created
      })
      return Object.values(by).map(c => ({ ...c, projects: [...c.projects].join(', '), branches: [...c.branches].join(', ') }))
    }
  },
  methods: {
    money,
    onPicked(p) { this.formVisible = false; this.version++; this.$router.push('/sitesProjects/projects/' + p.id) }
  }
}
</script>

<style scoped>
@import './sitesProjects.css';
</style>
